import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, injectGscVerification, trackPageview } from '../lib/analytics';

export function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    injectGscVerification();
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageview(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
}
